import useCopyTexture from "@/hooks/useCopyTexture";
import { useMemo } from "react";
import * as THREE from "three";

export default function useMaterial(textures, textureOptions, materialOptions) {
	if (!textures) {
		console.warn("No textures provided");
		return useMemo(() => new THREE.MeshStandardMaterial({ color: "red", roughness: 0.5 }), []);
	}

	// Get array of valid texture entries
	const textureEntries = Object.entries(textures).filter(([_, texture]) => Boolean(texture));

	// Process all available textures
	const processedTextures = useCopyTexture(textures, textureOptions) || [];

	// Memoize the material to avoid re-creating it on every render
	const material = useMemo(() => {
		const materialConfig = textureEntries.reduce((config, [key], index) => {
			const materialPropMap = {
				map: "map",
				normalMap: "normalMap",
				roughnessMap: "roughnessMap",
				aoMap: "aoMap",
			};

			const materialPropName = materialPropMap[key];

			if (materialPropName) {
				config[materialPropName] = processedTextures[index] || null;
			}

			return config;
		}, {});

		const newMaterial = new THREE.MeshStandardMaterial({
			...materialOptions,
			...processedTextures,
		});

		newMaterial.needsUpdate = true;
		return newMaterial;
	}, [processedTextures, materialOptions, textureEntries]);

	return material;
}
